"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function cruise(state) {
    return state.cruise;
}
exports.cruise = cruise;
function countries(state) {
    return state.countries;
}
exports.countries = countries;
function paymentCountries(state) {
    return state.paymentCountries;
}
exports.paymentCountries = paymentCountries;
function sexes(state) {
    return state.sexes;
}
exports.sexes = sexes;
function validations(state) {
    return state.validations;
}
exports.validations = validations;
function bookingNumber(state) {
    return state.booking.number;
}
exports.bookingNumber = bookingNumber;
function bookingError(state) {
    return state.booking.error;
}
exports.bookingError = bookingError;
function bookingLoading(state) {
    return state.booking.loading;
}
exports.bookingLoading = bookingLoading;
function bookingConfirmation(state) {
    return state.booking.confirmation;
}
exports.bookingConfirmation = bookingConfirmation;
function ships(state) {
    return state.ships;
}
exports.ships = ships;
// export everything compliant to the vuex specification for getters
exports.default = {
    cruise: cruise,
    countries: countries,
    paymentCountries: paymentCountries,
    sexes: sexes,
    validations: validations,
    bookingNumber: bookingNumber,
    bookingError: bookingError,
    bookingLoading: bookingLoading,
    bookingConfirmation: bookingConfirmation,
    ships: ships,
};
//# sourceMappingURL=getters.js.map